import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";


/**
 * 提案ステータスを不採用で更新するサービス
 *
 * @export UpdateSuggestionStatusRejectedService
 * @class UpdateSuggestionStatusRejectedService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateSuggestionStatusRejectedService extends PlessJsonResponderSub<null> {
  private model: KYMW6901ProposalTabModel;
  private proposalStatus: string;
  private successFunc = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateSuggestionStatusRejectedService
   */
  private getBody(): PlessRequest {

    return new PlessRequest({
      update: {
        updateSuggestionStatusRejected: {
          parameter: {
            ProposalId: this.model.newGoodsProposal.proposalId,
            ProposalStatus: this.proposalStatus,
            RejectionReason: this.model.newGoodsProposal.rejectedReason,
            ProposalBuyerId: this.model.newGoodsProposal.buyerUserId
          }
        }
      }

    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateSuggestionStatusRejectedService
   */
  execute(model: KYMW6901ProposalTabModel, proposalStatus: string, successFunc?: () => void): void {
    this.model = model;
    this.proposalStatus = proposalStatus;
    this.successFunc = successFunc;
    this.send('updateSuggestionStatusRejected', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * 
   * @memberof UpdateSuggestionStatusRejectedService
   */
  success(): void {
    if (this.successFunc) {
      this.successFunc();
    }
  }
}

